export const getNormalizeDate = (date, toType = "ru") => {
  if (date !== null && date !== undefined && typeof date === "string") {
    const engDateString = /\d\d\d\d-\d\d-\d\dT\d\d:\d\d:\d\d.000Z/;
    const rusTypeDate = /\d\d\.\d\d\.\d\d\d\d/g;
    const rusTypeDateAndTime = /\d\d\.\d\d\.\d\d\d\d.\d\d:\d\d:\d\d/g;
    const engTypeDate = /\d\d\d\d-\d\d-\d\d/g;
    const engTypeDateAndTime = /\d\d\d\d-\d\d-\d\d.\d\d:\d\d:\d\d/g;
    let d = null;
    let t = null;
    if (engDateString.test(date)) {
      const engDateString = /(\d\d\d\d)-(\d\d)-(\d\d)T(\d\d):(\d\d):(\d\d).000Z/;
      const newDate = date.match(engDateString);
      d = {
        day: newDate[3],
        mounth: newDate[2],
        year: newDate[1]
      };
      if (newDate[4] != "00" && newDate[5] != "00" && newDate[6] != "00") {
        t = {
          hour: newDate[4],
          minute: newDate[5],
          second: newDate[6]
        };
      }
    } else if (rusTypeDateAndTime.test(date)) {
      d = {
        day: date.split(/\s/)[0].split(".")[0],
        mounth: date.split(/\s/)[0].split(".")[1],
        year: date.split(/\s/)[0].split(".")[2]
      };
      t = {
        hour: date.split(/\s/)[1].split(":")[0],
        minute: date.split(/\s/)[1].split(":")[1],
        second: date.split(/\s/)[1].split(":")[2]
      };
    } else if (engTypeDateAndTime.test(date)) {
      d = {
        day: date.split(/\s/)[0].split("-")[2],
        mounth: date.split(/\s/)[0].split("-")[1],
        year: date.split(/\s/)[0].split("-")[0]
      };
      t = {
        hour: date.split(/\s/)[1].split(":")[0],
        minute: date.split(/\s/)[1].split(":")[1],
        second: date.split(/\s/)[1].split(":")[2]
      };
    } else if (rusTypeDate.test(date)) {
      d = {
        day: date.split(/\s/)[0].split(".")[0],
        mounth: date.split(/\s/)[0].split(".")[1],
        year: date.split(/\s/)[0].split(".")[2]
      };
    } else if (engTypeDate.test(date)) {
      d = {
        day: date.split(/\s/)[0].split("-")[2],
        mounth: date.split(/\s/)[0].split("-")[1],
        year: date.split(/\s/)[0].split("-")[0]
      };
    }
    if (toType == "ru") {
      if (t !== null) {
        return `${d.day}.${d.mounth}.${d.year} ${t.hour}:${t.minute}:${t.second}`;
      } else {
        return `${d.day}.${d.mounth}.${d.year}`;
      }
    } else if (toType == "en") {
      if (t !== null) {
        return `${d.year}-${d.mounth}-${d.day} ${t.hour}:${t.minute}:${t.second}`;
      } else {
        return `${d.year}-${d.mounth}-${d.day}`;
      }
    } else {
      throw new Error("No found a end type");
    }
  } else if (date !== null && date !== undefined && date instanceof Date) {
    return date;
  } else {
    return null;
  }
};
